<div class="footerContainer">
  <mat-toolbar color="primary"></mat-toolbar>
  <div class="row">
    <div class="footerLinks">
    <a href="https://www.woolworthsgroup.com.au" aria-label="Woolworths Group link"> Woolworths Group </a>
    <span>|</span>
    <a routerLink="/contact"> Contact Us </a>
    </div>
  </div>
  <div class="row">
    <span>© Woolworths Group 2023 All Rights Reserved ABN 88 000 014 675</span>
  </div>
</div>

